<template lang="pug">
v-container(fluid px-0 class=" tw-h-full tw-max-h-full tw-overflow-hidden ")
  v-row(v-if="tasks.length > 0" no-gutters class="")
    v-col(class=" pt-4 ")
      span(class=" tw-text-base tw-font-medium") {{ $t('Common.comingUp') }}
  v-row(no-gutters align="start" class=" tw-max-h-full tw-overflow-hidden  tw-h-full")
    v-col(align-self="stretch" class="overflow-hidden tw-h-full tw-max-h-full  ")
      div(v-if="tasks && tasks.length > 0" class="tw-h-full tw-max-h-full tw-overflow-y-scroll ")
        kubiqa-activity-item-sidebar-event(v-for="task in tasks" :key="task.id" :task="task" class="tw-my-6")
        div(class=" tw-h-56")
</template>
<script>
export default {
  computed: {
    tasks() {
      return this.$store.getters['user/tasksComingUp'];
    },
  },
  mounted() {
    let params = new URLSearchParams();
    params.append('filter[due_between][from]', this.$moment().subtract(15, 'days'));
    params.append('filter[due_between][to]', this.$moment().add(2, 'days'));
    params.append('filter[status]', 0);
    params.append('sort', 'due_date');
    this.$store.dispatch('user/getTasksComingUp', params);
  },
};
</script>
